import { useEffect, useRef } from 'react';
import { AlertTriangle } from 'lucide-react';
import './ConfirmDialog.css';

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'default' // 'default' | 'warning'
}) {
  const dialogRef = useRef(null);

  // Focus the dialog when opened and handle Escape key
  useEffect(() => {
    if (!isOpen) return;

    // Focus the dialog for keyboard accessibility
    dialogRef.current?.focus();

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div
        className="confirm-dialog"
        onClick={e => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        aria-describedby="confirm-message"
        ref={dialogRef}
        tabIndex={-1}
      >
        {variant === 'warning' && (
          <div className="confirm-icon">
            <AlertTriangle size={32} />
          </div>
        )}
        <h3 id="confirm-title">{title}</h3>
        <p id="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button onClick={onCancel} className="btn btn-dark">
            {cancelText}
          </button>
          <button onClick={onConfirm} className="btn btn-yellow">
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
